import React from 'react';
import PropTypes from 'prop-types';
import { Table, TBody, TR, TD } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';

class CarApprovedEmail extends React.Component {
  static propTypes = {
    content: PropTypes.shape({
      carId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      user: PropTypes.string,
      date: PropTypes.string,
      siteName: PropTypes.string,
      logo: PropTypes.string,
    }).isRequired
  };

  render() {
    const { content: { carId, user, date, siteName, logo } } = this.props;
    const textStyle = {
      color: '#333',
      backgroundColor: '#F7F7F7',
      fontFamily: 'Arial',
      fontSize: '16px',
      padding: '35px',
    };
    return (
      <Layout>
        <Header
          color="#2d8f4b"
          backgroundColor="#F7F7F7"
          logo={logo}
          siteName={siteName}
        />
        <div>
          <Table width="100%" >
            <TBody>
              <TR>
                <TD style={textStyle}>
                  <EmptySpace height={20} />
                  <div>
                    <b>Car Approval Request</b>
                  </div>
                  <EmptySpace height={20} />
                  <div>
                    <b>User:</b> {user || 'User'}
                  </div>
                  <EmptySpace height={10} />
                  <div>
                    <b>Car ID:</b> {carId}
                  </div>
                  <EmptySpace height={10} />
                  <div>
                    <b>Date:</b> {date}
                  </div>
                  <EmptySpace height={30} />
                  <div>
                    Please review and approve the car listing in the admin dashboard.
                  </div>
                  <EmptySpace height={40} />
                  <EmailSignature siteName={siteName} />
                </TD>
              </TR>
            </TBody>
          </Table>
          <EmptySpace height={40} />
        </div>
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }
}

export default CarApprovedEmail;
